import React, { useState, useEffect } from 'react'
import { Box } from '@mui/material'
import {
  ReportHeading,
  ProgressionWrapper,
  LoaderWrapper,
  ProgressionFilters,
  ReportOuterWrapper,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { useGlobalStore } from '../../../../store'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import { BrandImagerySimulator } from '..'
import { getObjectAsArray, getDistinctValues } from '../../../../util'

import { LhsTree } from './__mock.js'
import {
  OuterWrapper,
  ChartList,
  ChartLhs,
  BigArrow,
  ChartRhs,
  TabSection1,
  TabSection2,
} from './style'
import BrandMagnetScoreWarning from '../brandMagnetScoreWarning'
import BrandMagnetScoreWarningArray from '../brandMagnetScoreWarningArray'
import BrandMagnetScoreTree from '../brandMagnetScoreTree'

const ReportBrandMagnetScoreAndProgression = (props) => {
  const [rows, setRows] = useState([])
  const [reportExcelData, setReportExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { user } = useGlobalStore()

  const [progressionDataL1Filtered, setProgressionDataL1Filtered] = useState({
    brands: [],
    periods: [],
  })
  const [progressionDataFiltered, setProgressionDataFiltered] = useState({
    brands: [],
    periods: [],
  })
  const [configTab, setConfigTab] = useState([])
  const [eventCount, setEventCount] = useState(1)

  let scoreImageryTypeArray = {}
  let scoreImageryTypeArrayL2 = {}
  const filterDataObj = { brands: [], periods: [] }
  const hasTabs = props.InsightsElementType === 'BrandMagnetScoreAndProgression'

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: hasTabs
        ? ReportsService.reportGetMagnetScoreAndProgressionApi
        : ReportsService.reportGetMagnetScoreApi,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  const excelSheetFunc = (hasTabs, data) => {
    if (hasTabs) {
      const sheet1Object = data.filter((f) => f.tutorial === 'CurrentPeriod')?.[0]?.data || []
      const reportExcelSheet1DataObject = {
        heading: [
          { title: 'Brand', width: { wch: 30 } },
          { title: 'Brand Magnet Score', width: { wch: 30 } },
        ],
        values: sheet1Object.map((d) => {
          return [{ value: d.Entity.EntityName }, { value: d.BrandMagnetScore }]
        }),
      }
      // const getAllBrands = data.map(d1 => d1.data.map(d2 => d2.Entity.EntityName)).flat(1)
      const getAllBrands = getDistinctValues(
        data?.map((d1) => d1?.data?.map((d2) => d2.Entity.EntityName) || []).flat(1) || []
      )
      const reportExcelSheet2DataObject = {
        heading: [
          { title: 'Brand', width: { wch: 30 } },
          { title: 'Period' },
          { title: 'Brand Magnet Score', width: { wch: 30 } },
        ],
        values: [],
      }

      for (let i = 0; i < getAllBrands.length; i++) {
        for (let j = 0; j < data.length; j++) {
          const brandObject = data[j]?.data.find((f) => f.Entity.EntityName === getAllBrands[i])
          if (brandObject?.BrandMagnetScore) {
            reportExcelSheet2DataObject.values.push([
              { value: getAllBrands[i], width: { wch: 30 } },
              { value: data[j]?.title || '' },
              { value: brandObject?.BrandMagnetScore },
            ])
          }
        }
      }

      setReportExcelData({
        sheet1: reportExcelSheet1DataObject,
        sheet2: reportExcelSheet2DataObject,
      })
    } else {
      const sheet1Object = data[0] || []
      const reportExcelSheet1DataObject = {
        heading: [
          { title: 'Brand', width: { wch: 30 } },
          { title: 'Brand Magnet Score', width: { wch: 30 } },
        ],
        values: sheet1Object.map((d) => {
          return [{ value: d.Entity.EntityName }, { value: d.BrandMagnetScore }]
        }),
      }

      setReportExcelData({
        sheet1: reportExcelSheet1DataObject,
      })
    }
  }

  const generateProgressionGraphData = async (resp, hasTabs) => {
    scoreImageryTypeArray = {}
    scoreImageryTypeArrayL2 = {}

    const rowArrayDataFunc = (data, dataObj) => {
      filterDataObj.periods.push(dataObj?.title || '')
      filterDataObj.brands.push(data.map((d) => d.Entity.EntityName))

      const finalData = data.map((d) => {
        return {
          ...d,
          title: d.Entity?.EntityName,
          graphs: [
            {
              value: d?.BrandMagnetScore,
              barData: [{ Warning: d?.BrandMagnetScore }],
            },
          ],
        }
      })

      return finalData
    }

    const configTabObject = hasTabs
      ? resp.map((d, i) => {
          return {
            periodInsightsElementId: d.PeriodInsightsElementId,
            id: i,
            label: i === 0 ? d.PeriodName : 'Progression',
            tutorial: i === 0 ? 'CurrentPeriod' : 'Progression',
            title: d.PeriodName,
            periodOrder: d.PeriodOrder,
            data: getObjectAsArray(
              d.PeriodBrandCategoryMetricsElements.BrandCategoryMetricsElement
            ),
          }
        })
      : []

    const rowArrayData = hasTabs
      ? configTabObject.map((d) => {
          d.data = rowArrayDataFunc(d.data, d)
          return d
        })
      : [rowArrayDataFunc(resp, null)]

    const rowArray = hasTabs ? rowArrayData[0].data : rowArrayData[0]

    excelSheetFunc(hasTabs, rowArrayData)

    const removeUsingSet = (arr) => {
      let outputArray = Array.from(new Set(arr))
      return outputArray
    }
    const progressionDataL1FilteredData = {
      brands: removeUsingSet(filterDataObj.brands.flat(1)),
      periods: removeUsingSet(filterDataObj.periods),
    }
    setProgressionDataL1Filtered(progressionDataL1FilteredData)

    if (hasTabs) {
      setConfigTab(configTabObject)
    }

    const finalRowArray = rowArray
      .map((f) => ({ ...f, EntityType: f.Entity.EntityType }))
      .filter((f) => f.EntityType !== 'HiddenBrand')
    setRows(finalRowArray)
    updateSubLhsApiLoaded(props)
    setEventCount((p) => p + 1)
  }

  const BrandImagerySimulatorButton = () => {
    return (
      <>
        {ROLES_MM_PRIMARY.includes(user?.UserType) && false && (
          <BrandImagerySimulator {...props} brandMagnetTree={LhsTree} brandMagnetScore={rows} />
        )}
      </>
    )
  }

  const filterChangeFunc = (data) => {
    setProgressionDataFiltered(data)
  }

  const onSuccessFunc = (resp) => {
    generateProgressionGraphData(resp, hasTabs)
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props.type}
        subHeading=''
        {...props}
        additionalMiddleButton={<BrandImagerySimulatorButton />}
        downloadIdData={reportExcelData}
      />
      <ReportOuterWrapper>
        <OuterWrapper id={props.type}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <ProgressionWrapper
              configTab={configTab}
              onChange={() => setEventCount((p) => p + 1)}
              defaultTab={
                props?.isProgressionActive &&
                props.InsightsElementType === 'BrandMagnetScoreAndProgression'
                  ? 1
                  : 0
              }
            >
              {/* <ProgressionWrapper configTab={configTab} onChange={() => setEventCount(p => p+1)}> */}
              <TabSection1
                hasTabs={props.InsightsElementType === 'BrandMagnetScoreAndProgression'}
                className='brandMagnetScoreRows'
              >
                <ChartLhs className='chartLhs'>
                  <BrandMagnetScoreTree data={LhsTree} />
                </ChartLhs>
                <ChartRhs className='chartRhs'>
                  <BrandMagnetScoreWarning rows={rows} />
                </ChartRhs>
              </TabSection1>
              <TabSection2
                hasTabs={props.InsightsElementType === 'BrandMagnetScoreAndProgression'}
                className='chartLhsWrapper'
              >
                {/* <ProgressionFiltersWrapper>
                  {rows?.length > 0 && progressionDataL1Filtered?.brands?.length > 0 && <ProgressionFilters data={progressionDataL1Filtered} onChange={filterChangeFunc} />}
                </ProgressionFiltersWrapper> */}
                <ChartLhs className='chartLhs'>
                  <BrandMagnetScoreTree data={LhsTree} />
                </ChartLhs>
                <ChartRhs className='chartRhs'>
                  <BrandMagnetScoreWarningArray rows={rows} data={configTab} />
                </ChartRhs>
              </TabSection2>
            </ProgressionWrapper>
          </LoaderWrapper>
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportBrandMagnetScoreAndProgression
